/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import type { ResourceDataType } from './getData.tsx';

const RESOURCE_TYPE_FORGE_FIELD_CONTEXTUAL_CONFIG = 'FORGE_FIELD_CONTEXTUAL_CONFIG';

export const fieldContextConfigPageResource: RouteResource<ResourceDataType> =
	createResource<ResourceDataType>({
		type: RESOURCE_TYPE_FORGE_FIELD_CONTEXTUAL_CONFIG,
		getKey: () => 'data',
		getDataLoader: () =>
			import(
				/* webpackChunkName: "async-forge-field-context-config-resource", jiraSpaEntry: "async-forge-field-context-config-resource" */ './getData.tsx'
			),
		maxAge: 5 * 1000,
	});
